// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddPhoto_addPhotosContainer__GBYyW {
  width: 100%;
  margin: 12px auto 0 auto;
  font-size: 20px;
}

.AddPhoto_addPhotosTitle__4qo4\\+ {
  margin-bottom: 8px;
}

.AddPhoto_addFirstPhotoWrapper__--eI1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
  border: 1px solid rgba(17, 24, 39, 0.1);
  border-radius: 10px;
  transition: border 0.2s;
  cursor: pointer;
}

.AddPhoto_addFirstPhotoWrapper__--eI1 input[type=file],
.AddPhoto_addMorePhotos__yOYFc input[type=file] {
  display: none;
}

.AddPhoto_fontGrayThin__NN4L4 {
  color: gray;
  font-size: 16px;
  font-weight: 400;
}

.AddPhoto_addPhotoButton__R0jHV {
  width: 254px;
  height: 50px;
  background-color: rgba(17, 24, 39, 0.1);
  margin-top: 24px;
  color: black;
  font-weight: 400;
  font-size: 16px;
  transition: background-color 0.2s, color 0.2s;
  border-radius: 30px;
}

.AddPhoto_addFirstPhotoWrapper__--eI1:hover {
  border: 1px solid rgba(255, 111, 25, 0.3);
}
.AddPhoto_addFirstPhotoWrapper__--eI1:hover .AddPhoto_addPhotoButton__R0jHV {
  background-color: #ff6f19;
  color: white;
}

.AddPhoto_photosWrapper__jhc7U {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.AddPhoto_imagesCounter__jI6ls {
  background-color: #f0f0f0;
  border-radius: 10px;
  padding: 8px 18px;
  margin-left: 12px;
}

.AddPhoto_photoContainer__aeE\\+X {
  display: inline-block;
  position: relative;
  margin: 10px;
}

.AddPhoto_photoContainer__aeE\\+X img {
  width: 206px;
  height: 150px;
  border-radius: 10px;
}

.AddPhoto_addMorePhotos__yOYFc {
  margin-top: 10px;
  margin-left: 10px;
  width: 206px;
  height: 150px;
  border-radius: 10px;
  border: 1px solid rgba(59, 68, 255, 0.1);
  align-items: center;
  justify-content: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: border 0.2s;
}

.AddPhoto_addMorePhotoButton__YgxUu {
  width: 150px;
  height: 49px;
  background-color: rgba(17, 24, 39, 0.1);
  margin-top: 15px;
  border-radius: 30px;
  color: black;
  font-weight: 400;
  font-size: 16px;
  transition: background-color 0.2s, color 0.2s;
}

.AddPhoto_addMorePhotos__yOYFc:hover {
  border: 1px solid rgba(255, 111, 25, 0.3);
}
.AddPhoto_addMorePhotos__yOYFc:hover .AddPhoto_addMorePhotoButton__YgxUu {
  background-color: #ff6f19;
  color: white;
}

.AddPhoto_crossButton__NZJjb {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 33px;
  height: 33px;
  opacity: 85%;
  padding-left: 1px;
  background-color: #e7e8e9;
  transition: background-color 0.2s, color 0.2s;
}

.AddPhoto_crossButton__NZJjb:hover {
  background-color: #ff6f19;
}
.AddPhoto_crossButton__NZJjb:hover .AddPhoto_crossSvg__XgeB1 {
  stroke: white;
}

@media (width <= 530px) {
  .AddPhoto_photoContainer__aeE\\+X img {
    width: 140px;
    height: 95px;
    border-radius: 10px;
  }
}
@media (width <= 372px) {
  .AddPhoto_photoContainer__aeE\\+X img {
    width: 120px;
    height: 87px;
    border-radius: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/AddPhoto/AddPhoto.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,wBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,aAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,uCAAA;EACA,gBAAA;EAEA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,mBAAA;AACF;;AAEA;EACE,yCAAA;AACF;AAAE;EACE,yBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EAEA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,uCAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;AACF;;AAEA;EACE,yCAAA;AACF;AAAE;EACE,yBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,6CAAA;AACF;;AAEA;EACE,yBAAA;AACF;AAAE;EACE,aAAA;AAEJ;;AAGA;EACE;IACE,YAAA;IACA,YAAA;IACA,mBAAA;EAAF;AACF;AAGA;EACE;IACE,YAAA;IACA,YAAA;IACA,mBAAA;EADF;AACF","sourcesContent":[".addPhotosContainer {\n  width: 100%;\n  margin: 12px auto 0 auto;\n  font-size: 20px;\n}\n\n.addPhotosTitle {\n  margin-bottom: 8px;\n}\n\n.addFirstPhotoWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 0;\n  border: 1px solid rgb(17 24 39 / 0.1);\n  border-radius: 10px;\n  transition: border 0.2s;\n  cursor: pointer;\n}\n\n.addFirstPhotoWrapper input[type=\"file\"],\n.addMorePhotos input[type=\"file\"] {\n  display: none;\n}\n\n.fontGrayThin {\n  color: gray;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.addPhotoButton {\n  width: 254px;\n  height: 50px;\n  background-color: rgb(17 24 39 / 0.1);\n  margin-top: 24px;\n  border-radius: 10px;\n  color: black;\n  font-weight: 400;\n  font-size: 16px;\n  transition: background-color 0.2s, color 0.2s;\n  border-radius: 30px;\n}\n\n.addFirstPhotoWrapper:hover {\n  border: 1px solid rgb(255 111 25 / 0.3);\n  .addPhotoButton {\n    background-color: #ff6f19;\n    color: white;\n  }\n}\n\n.photosWrapper {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.imagesCounter {\n  background-color: #f0f0f0;\n  border-radius: 10px;\n  padding: 8px 18px;\n  margin-left: 12px;\n}\n\n.photoContainer {\n  display: inline-block;\n  position: relative;\n  margin: 10px;\n}\n\n.photoContainer img {\n  width: 206px;\n  height: 150px;\n  border-radius: 10px;\n}\n\n.addMorePhotos {\n  margin-top: 10px;\n  margin-left: 10px;\n  width: 206px;\n  height: 150px;\n  border-radius: 10px;\n  border: 1px solid rgba(59, 68, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  transition: border 0.2s;\n}\n\n.addMorePhotoButton {\n  width: 150px;\n  height: 49px;\n  background-color: rgb(17 24 39 / 0.1);\n  margin-top: 15px;\n  border-radius: 30px;\n  color: black;\n  font-weight: 400;\n  font-size: 16px;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.addMorePhotos:hover {\n  border: 1px solid rgb(255 111 25 / 0.3);\n  .addMorePhotoButton {\n    background-color: #ff6f19;\n    color: white;\n  }\n}\n\n.crossButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: none;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  width: 33px;\n  height: 33px;\n  opacity: 85%;\n  padding-left: 1px;\n  background-color: #e7e8e9;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.crossButton:hover {\n  background-color: #ff6f19;\n  .crossSvg {\n    stroke: white;\n  }\n}\n\n\n@media (width <= 530px) {\n  .photoContainer img {\n    width: 140px;\n    height: 95px;\n    border-radius: 10px;\n  }\n}\n\n@media (width <= 372px) {\n  .photoContainer img {\n    width: 120px;\n    height: 87px;\n    border-radius: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addPhotosContainer": `AddPhoto_addPhotosContainer__GBYyW`,
	"addPhotosTitle": `AddPhoto_addPhotosTitle__4qo4+`,
	"addFirstPhotoWrapper": `AddPhoto_addFirstPhotoWrapper__--eI1`,
	"addMorePhotos": `AddPhoto_addMorePhotos__yOYFc`,
	"fontGrayThin": `AddPhoto_fontGrayThin__NN4L4`,
	"addPhotoButton": `AddPhoto_addPhotoButton__R0jHV`,
	"photosWrapper": `AddPhoto_photosWrapper__jhc7U`,
	"imagesCounter": `AddPhoto_imagesCounter__jI6ls`,
	"photoContainer": `AddPhoto_photoContainer__aeE+X`,
	"addMorePhotoButton": `AddPhoto_addMorePhotoButton__YgxUu`,
	"crossButton": `AddPhoto_crossButton__NZJjb`,
	"crossSvg": `AddPhoto_crossSvg__XgeB1`
};
export default ___CSS_LOADER_EXPORT___;
